{
  "+/na8S": "{experienceLevel} 的职位空缺",
  "+RBfjK": "<strong>政府机关</strong>——在法律、法规或法律程序要求的情况下。",
  "+lsg50": "<strong>事务性沟通：</strong>发送申请状态更新、面试提醒、入职说明以及其他与您的申请或就业直接相关的沟通信息（根据您的同意选择，通过短信、电子邮件或电话）。",
  "/GKTwV": "{startResult} - {endResult} 的 {totalCount}",
  "/SZPmm": "按职位名称或关键词搜索",
  "/pdLnE": "<strong>删除权：</strong>您可以要求我们删除您的个人信息，但须遵守某些法律例外情况（例如记录保存义务）。",
  "00m1vT": "<strong>自动收集的数据：</strong>根据我们平台提供商的标准数据保留政策进行保留。",
  "06JQuf": "5. 免责声明",
  "0uj8CA": "您可能符合条件的就业机会和职位（市场营销）",
  "0xKvFl": "<strong>查阅权：</strong>您可以要求获取我们持有的关于您的个人信息的副本。",
  "1MNiI4": "选择 {name}",
  "1QOHHT": "工作时间",
  "1WIMxg": "取消",
  "1ma4gO": "当您与我们的招聘网站互动时，我们可能会收集以下几类个人信息：",
  "2YzWOm": "申请",
  "2gDsJ9": "请调整您的搜索和筛选条件。",
  "2ysiB3": "清除所有筛选条件",
  "3CLJU9": "请通过以下方式联系我们：<supportLink> {supportContact}</supportLink>",
  "3NW9w+": "{accountName} 隐私政策",
  "3RG7Do": "6.你的权利和选择",
  "3Yr6Zd": "1. 本网站的使用",
  "3oHMyk": "根据您所在地区，您可能拥有以下关于个人信息的权利：",
  "3qpbhl": "10. 数据安全",
  "3v8etI": "{position} 的职位空缺",
  "41OEjv": "我们会直接从您那里收集个人信息（通过申请表），并通过我们的平台提供商的技术自动收集个人信息（通过嵌入我们招聘网站的 cookie 和类似技术）。",
  "4ohioF": "<strong>平台运营：</strong>我们授权平台提供商（Fountain）代表我们维护招聘网站的安全性和功能，包括检测欺诈行为和解决技术问题。",
  "56kYFg": "<strong>与申请相关的短信：</strong>状态更新、面试提醒、入职说明以及其他与您的申请或在{accountName}工作直接相关的消息。<em>（交易型）</em>",
  "5c0xwM": "选择退出后，您将收到一条确认信息。您可以通过招聘网站重新注册，或者回复我们的任何消息发送短信“START”来重新订阅。",
  "6I7QkP": "当地的",
  "6gJsj3": "隐私权政策",
  "7EUdCR": "当您通过我们的招聘网站提交申请时，您的个人信息将由我们的平台提供商（Fountain）代表我们直接收集。我们还可能与以下几类服务提供商共享您的个人信息，以协助我们开展招聘流程：",
  "7HOdgz": "未找到 ({location}) 附近的职位空缺",
  "7K2KnA": "筛选",
  "7O1CGZ": "如果您对本隐私政策有任何疑问或希望行使您的任何权利，请联系我们：",
  "7srJEb": "在 {brandName} 寻找你的下一个机会",
  "8R2FQ7": "申请",
  "8YcgIg": "/年",
  "8lJb89": "生效日期：2026年4月",
  "8moA7E": "在我们的申请表上勾选选择加入框，即表示您同意接收来自 {accountName} 的短信，发送至您提供的电话号码。信息可能包含：",
  "9Jg0WQ": "排序方式",
  "9TzuJX": "职位",
  "9ZVuvw": "<supportLink>{supportContact}</supportLink>",
  "9fotW7": "如何选择退出：",
  "9gvBvK": "职位类型",
  "A939ot": "清除",
  "AEkpsv": "永恒的",
  "AXM0Ru": "隐私权政策",
  "Af+l/5": "{count, plural, other {现有{count,number}个职位空缺}}",
  "AkOXuk": "<strong>设备和使用数据：</strong> IP 地址、浏览器类型、设备标识符、操作系统以及根据您的 IP 地址推断出的大致位置",
  "Apa4NB": "11. 儿童隐私",
  "BwwT2Q": "<strong>互动数据：</strong>您在我们招聘网站上访问的页面、停留时间以及在申请过程中采取的操作。",
  "C/40b0": "职位",
  "C5OA4b": "一旦您的个人信息不再需要用于上述任何目的，我们将与我们的平台提供商协调，根据适用的数据保留和处置程序安全地删除或匿名化您的个人信息。",
  "CIaoJm": "员工登录",
  "CfEcpR": "<strong>不受歧视的权利：</strong>我们不会因为您行使任何隐私权而对您进行歧视。",
  "DTxAgM": "<strong>知情权：</strong>您可以要求获取有关我们收集的关于您的个人信息的类别和具体内容、该信息的来源、收集目的以及我们与之共享该信息的第三方类别的信息。",
  "DaFtVe": "<strong>背景调查提供商</strong>——如果您在招聘过程中进入下一阶段并提供单独的同意，我们可能会与第三方提供商共享信息以进行背景调查。",
  "E+ZmsH": "我们的招聘网站由我们的平台提供商（Fountain）运营，使用 cookie 和类似技术来收集第 2 节中描述的设备和使用数据。这些技术由 Fountain 代表我们部署，用于运营招聘网站、分析使用情况和提高性能。有关我们招聘网站上使用的特定 Cookie 的详细信息，请参阅 Fountain 的隐私政策。<fountainPrivacyLink> fountain.com/privacy</fountainPrivacyLink> 。",
  "E2+MeX": "<strong>请勿追踪信号：</strong>我们的招聘网站目前不响应“请勿追踪”（DNT）浏览器信号。目前，对于识别或响应 DNT 信号，行业内还没有统一的标准。",
  "ECDDUw": "如果您选择退出，我们将立即处理您的请求。选择不接收营销信息不会影响与有效申请或雇佣关系相关的交易信息，除非您单独选择不接收这些信息。",
  "EJyETf": "在申请过程中，您可能会被要求对以下每种沟通方式分别提供同意：",
  "EZ7l60": "选择距离",
  "F4rSq/": "<strong>消息频率：</strong>消息频率根据您的应用程序状态和活动而有所不同。可能适用标准短信和数据流量费用。",
  "FD+Ak4": "筛选",
  "FbMyuc": "<strong>短信同意记录：</strong>如果您选择接收短信，我们会收集并保留您的同意记录。",
  "Fza3xO": "{count, plural, other {{query}（所有地点）共有 {count,number} 个职位空缺}}",
  "G3uSr3": "排序方式：",
  "GLUAB+": "{category} 的职位空缺",
  "GiGPOp": "<strong>处理您的申请：</strong>评估您的资格、安排面试、进行背景调查（必要时需征得您的单独同意），并与您沟通您的申请状态。",
  "GnfGtK": "我们建议您定期查看此政策。您在变更发布后继续使用我们的招聘网站并不代表您同意修订后的条款——任何需要您同意的处理都将受单独的同意机制约束。",
  "GoyAbs": "“{query}”的搜索结果",
  "Gx/VZ8": "全职",
  "HjtQ1S": "<strong>我们不会出售您的个人信息。我们也不会将您的个人信息用于跨平台行为广告。</strong>",
  "IPBVH3": "9. Cookie、跟踪技术和“请勿跟踪”",
  "J4l/AQ": "行政及专业",
  "J8cmAm": "显示更多 ({count})",
  "JC1ICT": "补偿类型",
  "Jlcabf": "<strong>敏感个人信息：</strong>根据职位和适用法律，我们可能会收集政府颁发的身份识别号码（例如社会保障号码或驾驶执照号码）以用于就业核实或背景调查。我们仅出于法律允许的特定目的处理敏感个人信息，不会将其用于用户画像或广告宣传。加州居民有权限制我们对敏感个人信息的使用——请参阅第 6 节。",
  "JtmXU+": "搜索 {name}",
  "KDjhll": "当我们从欧盟/欧洲经济区或英国向美国传输个人信息时，我们依赖以下保障措施：（a）欧盟-美国数据隐私框架（DPF）（如适用）；和/或（b）经欧盟委员会批准的标准合同条款（SCC），这些条款已纳入我们与服务提供商的数据处理协议中。您可以联系我们索取适用保障措施的副本。<supportLink> {supportContact}</supportLink> 。",
  "KrXS5/": "回复我们发送的任何短信“STOP”即可取消订阅。",
  "L1t2kd": "信息发送频率不固定。可能产生短信和数据流量费用。",
  "LOXUJb": "使用的 Cookie 类型：",
  "Lbwy5v": "职位名称",
  "LtyZus": "<strong>求职短信：</strong>提供您可能符合条件的其他{accountName}职位信息。<em>（营销——需要单独选择加入）</em>",
  "MCzo6Q": "<strong>工作机会电话：</strong>关于您可能符合条件的其他{accountName}职位的电话。<em>（营销——需要单独选择加入）</em>",
  "Mf37lr": "热门类别",
  "Mh1F+e": "{count, plural, other {找到 {count,number} 个远程工作岗位}}",
  "NG6g7y": "半径",
  "Nkxa4f": "所有服务提供商均有合同义务保护您的信息，仅将其用于我们指定的用途，并且不得将其保留超过提供服务所必需的时间。",
  "OpSpNa": "我们会将您的个人信息保留至合理必要的期限，以实现收集该信息的目的，包括提供您所要求的服务、处理和评估您的申请、支持任何由此产生的雇佣关系、履行我们的法律和监管义务以及解决争议。",
  "OuE0df": "<strong>选择退出出售/共享的权利：</strong>我们不会出售或共享您的个人信息用于跨情境行为广告。无需选择退出，因为我们不参与这些行为。",
  "OxK884": "财务与会计",
  "PkU5jD": "<strong>所有渠道：</strong>联系方式<supportLink>{supportContact}</supportLink>更新或撤销您在所有通信渠道中的同意偏好。",
  "Q43kt/": "<strong>与申请相关的电话：</strong>关于您的申请状态、面试安排和入职的电话。<em>（交易型）</em>",
  "QHXX/I": "<strong>通信服务提供商</strong>——电话运营商和短信服务提供商，用于发送短信和拨打电话。我们可能会与帮助我们提供短信服务的第三方共享您的个人数据，包括您的短信选择加入或同意状态，包括但不限于平台提供商、电话公司以及协助发送短信的任何其他供应商。这种共享仅用于提供服务的目的。",
  "Qc+F6I": "每一项同意选择都是<strong>独立的</strong>。您可以选择接收其中任何一种、全部或不接收任何类型的通讯信息。您的选择不会影响您的申请。",
  "Qjh8MV": "<strong>如何获得帮助：</strong>回复任意短信<strong>“HELP”</strong>即可获得帮助，或联系我们。<supportLink> {supportContact}</supportLink> 。",
  "QmFp6b": "<strong>Fountain, Inc</strong> .——我们的招聘平台提供商。Fountain 代表我们收集和处理您的个人信息，以方便申请流程、发送短信和其他通信以及管理招聘工作流程。Fountain 的隐私政策可在以下网址查看：<fountainPrivacyLink> fountain.com/privacy</fountainPrivacyLink> 。",
  "R+laqn": "类别",
  "R5pOCA": "查看下方 {brandName} 的所有可用职位空缺，或搜索其他地点的职位空缺。",
  "RdNN/i": "任何",
  "RhRgl7": "<strong>更正权：</strong>您可以要求我们更正不准确的个人信息。",
  "RwsNjX": "2. 短信服务",
  "ShbUPK": "城市",
  "T0z9P/": "{count, plural, other {在 {radius} {unit} 中找到 {count,number} 个职位，共 {location} 个职位}}",
  "TBEZ9x": "职位名称",
  "TuoZCm": "寻找您的下一个机会",
  "UKI/HU": "全部",
  "Ud728E": "在适用法律允许的最大范围内，{accountName} 对您使用本网站或我们的短信服务而引起的任何间接、附带、特殊或后果性损害不承担任何责任。",
  "V/osST": "当前位置",
  "VC3i9i": "本网站及其内容均按“原样”提供，不提供任何形式的明示或暗示的保证。我们不保证网站不会中断或出现错误。",
  "VcjP63": "您的个人信息可能会被传输到美国并在美国进行处理，因为我们的平台提供商 Fountain 在美国运营其主要基础设施。美国可能无法提供与您所在国家/地区相同水平的数据保护。",
  "VguvIP": "{count, plural, other {有 {count,number} 个职位空缺，面向 {query}}}",
  "VoPWLM": "搜索类别",
  "Vvd1rH": "我们可能会定期更新这些条款。条款变更发布后，您继续使用本网站即表示您接受修订后的条款。",
  "WT6YVK": "上一个",
  "WjwoSF": "<strong>短信同意记录：</strong>为遵守监管规定，至少保留五 (5) 年，符合运营商和 FCC 的记录保存要求。",
  "WuHcvG": "我们的招聘网站由<strong>Fountain, Inc.</strong> （“Fountain”）提供技术支持，Fountain 是一个劳动力管理平台，作为我们的服务提供商，代表我们处理您的个人信息。Fountain 作为数据处理者；我们是数据控制者，负责决定如何以及为什么处理您的个人信息。",
  "X1Y9Ps": "按职位名称搜索",
  "XPamEN": "/小时",
  "XcuBSu": "所有可用职位",
  "XjSvOF": "运营与领导力",
  "YDhGHb": "7. 数据保留",
  "YQbDhN": "服务条款",
  "YbL2yB": "<strong>就业信息：</strong>工作经历、教育背景、技能、证书以及对申请问题的回答",
  "Yoy6Jy": "查看下方 {brandName} 的所有可用职位空缺，或搜索其他地点的职位空缺。",
  "Z4YDPm": "<strong>申请资料：</strong>如果您被录用，您的申请资料将在雇佣关系存续期间以及此后一段合理的时间内保留，具体保留期限根据适用的雇佣、税务和记录保存法律的要求而定。如果您未被录用，您的申请资料通常会保留一段时间，以便考虑未来的就业机会并遵守法律法规要求，除非法律要求更短或更长的保留期限。",
  "a37+C1": "申请状态更新、入职信息和其他与就业相关的通知（事务性）",
  "aD7/QV": "兼职",
  "aKWnwv": "页面",
  "aaT0rw": "当您访问我们的招聘网站时，我们的平台提供商（Fountain）会代表我们自动使用 cookie 和类似技术收集某些信息。这可能包括：",
  "avRBAo": "发布日期",
  "bQxKXO": "远程",
  "c0TwrW": "按职位名称或地点搜索",
  "cP462m": "{count, plural, other {现有{count,number}个职位空缺（所有地点）}}",
  "cScov5": "<strong>短信：</strong>回复<strong>“STOP”</strong>即可停止发送任何短信。回复“停止”即可取消接收该号码发送的<strong>所有短信</strong>。如果您只想选择退出某一类短信（例如，营销短信但不包括交易短信），请联系我们。<supportLink> {supportContact}</supportLink>以细粒度方式更新您的偏好设置。",
  "ccduZH": "<strong>欧盟/欧洲经济区/英国申请人：</strong>根据电子隐私指令（指令 2002/58/EC）或英国隐私和电子通信条例（PECR）的要求，我们将在放置非必要 cookie 之前征得您的同意。您可以通过浏览器设置管理您的 Cookie 偏好设置。",
  "cnNa4F": "由于您的个人信息是通过我们的平台提供商（Fountain）处理的，我们可能会与 Fountain 协调以满足您的请求。这不会影响您直接向我们提交请求的权利，我们仍有责任在适用法律规定的时间内回复您。",
  "coNrE4": "<strong>来电：</strong>请告知来电者您希望被移除，或联系我们。<supportLink> {supportContact}</supportLink> 。",
  "ctMrd+": "<strong>不会将任何移动信息（包括手机号码和短信选择加入或同意数据）分享给第三方或关联公司用于其营销或推广目的。</strong>除短信发送者选择加入数据和同意外，所有其他类别均不包含此类信息；此类信息不会与任何第三方共享。",
  "dHKLYk": "与我们聊天",
  "dINcE1": "搜索职位",
  "dMBRRH": "内部招聘网站",
  "dSrjr/": "本隐私政策描述了当您通过我们的招聘网站申请职位时， <strong>{accountName}</strong> （“我们”）如何收集、使用和保护您的个人信息。",
  "eN7CVI": "8. 这些条款的变更",
  "ePJ10M": "距离",
  "eWWpS5": "穿梭",
  "ejsFwD": "6. 责任限制",
  "eoLsYT": "未找到工作",
  "epJ7rX": "1. 我们是谁",
  "esYqDb": "13. 联系我们",
  "f5ZXVy": "本条款受特拉华州法律管辖并按其解释，不考虑其冲突法条款。因本条款引起的任何争议均应由位于特拉华州的州法院和联邦法院专属管辖。",
  "f5xlBv": "{count, plural, other {在 {location} 附近找到 {count,number} 个工作岗位}}",
  "f9XZvs": "服务条款",
  "fHwoN4": "<strong>任何移动信息（包括手机号码、短信选择加入状态和同意数据）均不会被分享、出售或出租给第三方或关联公司用于其营销或推广目的。</strong>移动端选择加入和同意信息仅与通信服务提供商（例如运营商和消息平台供应商）共享，且仅限于向您发送所请求的消息所必需的情况，不会用于任何第三方的独立营销用途。",
  "fqbMOd": "位置",
  "fz8Tvp": "<strong>绝对必要的 cookie：</strong>招聘网站运行所必需的（例如，会话管理、安全）。这些功能无法禁用。",
  "gKKaX9": "同意接收短信并非申请或获得工作的条件。",
  "ggOC46": "如果您对 Fountain 平台如何处理您的数据有任何疑问，也可以联系 Fountain 的隐私团队：<privacyMailLink> privacy@fountain.com</privacyMailLink>",
  "h8XXuO": "5. 我们如何共享您的信息",
  "hCJFEI": "8. 对于欧盟/欧洲经济区/英国申请人：国际数据传输",
  "hNt7Xn": "搜索",
  "hph9/b": "3. 我们如何使用您的信息",
  "iVSyX5": "任何",
  "iwEvY/": "<strong>识别信息：</strong>姓名、电子邮件地址、电话号码、邮寄地址",
  "jPYzxK": "2. 我们收集的信息",
  "jW9g8Q": "/月",
  "jjNqku": "选择位置",
  "kDYV94": "远程办公、在家办公、居家办公、远程办公",
  "kFJ1hG": "清除",
  "ki+WBr": "/天",
  "kkx0Di": "{count, plural, other {找到 {count,number} 个远程工作机会 {query}}}",
  "lDKw0M": "<strong>入职：</strong>如果您获得职位，我们将协助您完成入职流程，包括收集文件、安排培训和入职培训。",
  "lwRtGv": "搜索位置",
  "mOqk1N": "<strong>限制使用敏感个人信息的权利：</strong>如果我们收集敏感个人信息（例如社会保障号码或政府颁发的身份证），您有权限制我们仅将该信息用于提供您合理期望的服务所必需的目的。如需行使此项权利，请联系我们。<supportLink> {supportContact}</supportLink> 。",
  "mqm7rH": "<strong>分析型 Cookie：</strong>帮助我们了解求职者如何与招聘网站互动。这些数据可能由第三方分析服务提供商提供。",
  "mvv/A1": "您附近的职位空缺{location}",
  "n/WRpL": "未找到 {location} 附近的职位空缺",
  "n4YEE0": "清除",
  "nUNDHI": "我们会采取合理措施确保您的个人信息受到保护。由于您的数据是通过我们的平台提供商（Fountain）处理的，因此我们依赖于 Fountain 的技术和组织安全控制，其中包括 SOC 2 II 型认证、ISO 27001:2022 认证以及传输中数据（TLS 1.2+）和静态数据（AES-256）的加密。我们与 Fountain 签订了数据处理协议，该协议要求 Fountain 采取适当的安全措施来保护您的个人信息。",
  "nUYXYf": "合同工/自由职业者",
  "nrL6lE": "查看更多 ({count})",
  "ntF3q4": "<strong>授权代理人：</strong>您可以指定一名授权代理人代表您提交隐私请求。代理人必须提供您的授权证明（例如签署的书面许可或授权委托书），我们可能仍会要求您直接验证您的身份。",
  "nxt8Qc": "选择类别",
  "o5G5gO": "按位置搜索",
  "o5Lr3P": "<strong>法律合规：</strong>履行我们的法律义务，包括记录保存、税务申报、就业资格核实以及回应政府机构的合法要求。",
  "oV4vX7": "可用职位",
  "oojjh4": "使用由 {accountName}（“我们”、“我们的”）运营的网站，即表示您同意这些服务条款。",
  "pCgcIl": "我们使用您的个人信息用于以下目的：",
  "pXg8OU": "<strong>市场营销信息：</strong>如果您单独选择接收，我们将向您发送有关您可能符合条件的其他工作机会的信息。",
  "pfzWdN": "随意的",
  "pjY7EJ": "<strong>文件：</strong>简历、政府颁发的身份证明（如工作需要核实身份），以及您在申请或入职过程中上传的其他文件。",
  "poL3TM": "电子邮件：<supportLink> {supportContact}</supportLink>",
  "puJXDp": "3. 如何获得帮助",
  "qt4wYG": "{accountName} 隐私政策",
  "r1QaDh": "没有任何一种传输或存储方法是完全安全的。虽然我们尽力保护您的个人信息，但我们无法保证绝对安全。",
  "r7Kb/z": "无可用选项",
  "rUGq0i": "国家/地区",
  "rdOcXL": "退出登录",
  "rth6q8": "筛选",
  "s0o3E7": "搜索 {brandName} 的职位空缺",
  "sEzBNV": "<strong>是否同意接收短信或电话完全出于自愿，并非提交求职申请或获得工作的条件。</strong>如果您选择不接收我们的邮件，我们可能会通过电子邮件与您联系。",
  "sR3x84": "学员",
  "sox8LY": "我们可能会不时更新本隐私政策。如果我们对处理您的个人信息的方式做出重大改变，我们将：(a) 在我们的招聘网站上发布醒目的通知，以及 (b) 在可行的情况下，通过存档的联系信息通知已提交有效申请的申请人。更新后的政策将注明修订后的生效日期。",
  "stlhl5": "<strong>加州居民：</strong>根据经《加州隐私权法案》（CCPA/CPRA）修订的《加州消费者隐私法案》，您享有上述所有权利。如需提交可验证的消费者请求，请联系我们：<supportLink> {supportContact}</supportLink> 。我们将在满足您的请求之前核实您的身份，并按照法律规定在 45 天内作出答复。",
  "syNys9": "{count, plural, other {在 {radius} {unit} 中找到 {count,number} 个与 {query} 相关的职位，共 {location} 个职位。}}",
  "tIQhbD": "客户服务与运营",
  "tXdMLm": "我们的招聘网站不面向16岁以下人士。我们不会故意收集16岁以下儿童的个人信息。如果您认为我们收集了儿童的信息，请联系我们：<supportLink> {supportContact}</supportLink>这样我们就可以及时删除它。",
  "tYpw2s": "靠近 ({location}) 的职位空缺",
  "tbs+f9": "{accountName} 隐私政策和使用条款",
  "tdTJ7T": "4. 如何选择退出",
  "toqXyd": "服务条款",
  "tsGjFK": "英里",
  "uMkyWa": "您直接提供的信息：",
  "uq79O0": "地点名称",
  "uy6hZs": "州/省",
  "w3RZCZ": "职位",
  "w7EwgX": "12. 本隐私政策的变更",
  "wWh0//": "{count, plural, other {在 {location} 附近找到 {count,number} 个与 {query} 相关的职位}}",
  "wdw5oL": "9. 联系我们",
  "wqAadg": "区域",
  "x+3jJQ": "公里",
  "xUezuu": "保留期限取决于我们平台提供商（Fountain）的功能和配置。如果您对具体的保留期限有任何疑问，请联系我们。<supportLink> {supportContact}</supportLink> 。",
  "xbL6qz": "7. 适用法律",
  "xgBjTg": "信息技术",
  "yIC7Pq": "{lastPage}的",
  "yJcC0I": "4. 短信和电话通信计划",
  "yfcesY": "通过我们的平台提供商自动收集的信息：",
  "zBwVKO": "远程",
  "zKRBxT": "本网站由 {accountName} 运营，旨在方便求职申请和与就业相关的沟通。您同意仅出于合法目的并按照这些条款使用本网站。",
  "zPvAKV": "临时",
  "zabbLE": "下一个"
}
